
(() => {
  if (window.pruuvoCartCountSyncLoaded) return;
  window.pruuvoCartCountSyncLoaded = true;
  window.pruuvoCartCountSyncVersion = '3';

  const originalFetch = window.fetch.bind(window);
  let timer;
  let revision = 0;

  function isCartRequest(input) {
    try {
      const url = new URL(input instanceof Request ? input.url : input, location.href);
      if (url.origin === 'https://api.razorpay.com' &&
          /^\/v1\/magic\/sidecart\/update\/?$/.test(url.pathname)) {
        return true;
      }
      return url.origin === location.origin &&
        /\/cart(?:\/(?:add|change|update|clear))?(?:\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  function paint(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('.pv-cartcount').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  function scheduleRefresh() {
    const currentRevision = ++revision;
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await originalFetch(`${root}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (currentRevision === revision) paint(cart.item_count);
      } catch (error) {
        console.warn('Pruuvo cart badge refresh failed:', error);
      }
    }, 100);
  }

  // Observe requests without changing their arguments or consuming their responses.
  window.fetch = function (...args) {
    const result = originalFetch(...args);
    if (!isCartRequest(args[0])) return result;
    return result.then((response) => {
      if (response.ok) scheduleRefresh();
      return response;
    });
  };

  // Razorpay and other theme integrations may also use XMLHttpRequest.
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  const cartRequests = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    const result = originalOpen.call(this, method, url, ...rest);
    cartRequests.set(this, isCartRequest(url));
    return result;
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (cartRequests.get(this)) {
      this.addEventListener('loadend', function onComplete() {
        this.removeEventListener('loadend', onComplete);
        if (this.status >= 200 && this.status < 300) scheduleRefresh();
      });
    }
    return originalSend.apply(this, args);
  };

  // The sidecart iframe sends this message after its own cart update.
  // Its network requests do not pass through the storefront's fetch/XHR wrappers.
  window.addEventListener('message', (event) => {
    try {
      const origin = new URL(event.origin);
      if (origin.protocol !== 'https:' ||
          !/(^|\.)razorpay\.(com|in)$/.test(origin.hostname)) return;
      const fromSidecart = Array.from(
        document.querySelectorAll('iframe.razorpay-sidecart-frame')
      ).some((frame) => frame.contentWindow === event.source &&
        new URL(frame.src, location.href).origin === event.origin);
      if (!fromSidecart) return;

      const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (message?.source !== 'sidecart' || message.eventType !== 'async_event') return;
      const payload = message.payload;
      if (payload?.name === 'update_cart') {
        const data = payload.data;
        if (data?.skipShopifySync && Number.isInteger(data.itemCount) && data.itemCount >= 0) {
          ++revision;
          clearTimeout(timer);
          paint(data.itemCount);
        } else {
          scheduleRefresh();
        }
      } else if (payload?.name === 'add_to_cart') {
        scheduleRefresh();
      }
    } catch {
      // Ignore unrelated or malformed frame messages.
    }
  });

  window.addEventListener('pageshow', scheduleRefresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleRefresh();
  });
  scheduleRefresh();
})();
